import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { colors } from '@/styles'
import { Button } from '@/components/button'
import BackArrow from './back-arrow.svg?react'

const StyledButton = styled(Button)`
  color: ${({ color }) => color ?? colors.blue32};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ gap }) => gap ?? '8px'};
  font-size: ${({ fontSize }) => fontSize ?? '14px'};
  padding: ${({ padding }) => padding ?? '8px'};
  width: 82px;
  height: 32px;
  min-width: unset;
  min-height: unset;

  &:not(:disabled):not([aria-disabled='true']) {
    color: ${({ color }) => color ?? colors.blue32};
  }
`

const BackButton = ({ onClick, Icon = BackArrow, ...props }) => {
  const { t } = useTranslation()

  return (
    <StyledButton theme="text" onClick={onClick} {...props}>
      <Icon /> {t('common.back', 'Back')}
    </StyledButton>
  )
}

export default BackButton
